import { registerQuery, useSuspenseQuery } from 'data-fetching-client';
import Raven from 'raven-js';
import { getAppPermissionTranslationsRpc } from '../../../../../__generated__/chirp/com/hubspot/app/permissions/hublets/rpc/AppPermissionsHubletsPublicRpc';
import { rpcClientNoPortal } from '../../../../shared/rpc-client';
import getLang from 'I18n/utils/getLang';
const fetchAppPermissionTranslationsPublic = ({
  appPermissionNames,
  locale
}) => {
  return rpcClientNoPortal.call(getAppPermissionTranslationsRpc, {
    request: {
      appPermissionNames,
      locale
    }
  }).then(response => {
    const translationMap = response.translations.reduce((acc, translation) => {
      acc.set(translation.appPermissionName, translation);
      return acc;
    }, new Map());
    return translationMap;
  }).catch(e => {
    Raven.captureException(e, {
      extra: {
        message: 'Error fetching app permission translations, returning empty map!',
        appPermissionNames
      }
    });
    // Return an empty map instead of throwing an error since this is not a critical error and we want to avoid blocking the UI.
    return new Map();
  });
};
const GET_APP_PERMISSION_TRANSLATIONS_PUBLIC = registerQuery({
  fieldName: 'appPermissionTranslationsPublic',
  args: ['appPermissionNames', 'locale'],
  fetcher: fetchAppPermissionTranslationsPublic
});
export const useGetAppPermissionTranslationsPublic = appPermissionNames => {
  return useSuspenseQuery(GET_APP_PERMISSION_TRANSLATIONS_PUBLIC, {
    variables: {
      appPermissionNames,
      locale: getLang()
    }
  }).data.appPermissionTranslationsPublic;
};